import { FinanceValueObjectsContactTypeEnum } from 'generated/resources/graphql'

import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { FinanceContactModal } from './FinanceContactModal'

type FinanceContactCreateActivityProps = {
  refetchQuery?: string
  name?: string
  contactCreateType: FinanceValueObjectsContactTypeEnum
  validateOnCreate?: 'validateOnCreate'
}

export const FinanceContactCreateActivity: ActivityComponent<FinanceContactCreateActivityProps> = (
  data
) => {
  const { open, closeActivity } = useActivity()
  const { name, contactCreateType, refetchQuery, validateOnCreate } = data

  return (
    <FinanceContactModal
      isOpen={open}
      onClose={closeActivity}
      name={name}
      contactCreateType={contactCreateType}
      refetchQuery={refetchQuery}
      validateOnCreate={!!validateOnCreate}
    />
  )
}
